import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import PieGraph from "../../../general/PieGraph";
import styles from "./EducationL1.module.css";
import { EducationStore } from "./EducationStore";

function EducationL1({ distrito }) {
  const [nivelEscolaridade, setNivelEscolaridade] = useState(null);
  const [matriculaEscola, setMatriculaEscola] = useState(null);
  const [qualidadeEscolasRurais, setQualidadeEscolasRurais] = useState(null);
  const [nivelEscolaridadeOldValue, setNivelEscolaridadeOldValue] =
    useState(null);
  const [matriculaEscolaOldValue, setMatriculaEscolaOldValue] = useState(null);
  const [qualidadeEscolasRuraisOldValue, setQualidadeEscolasRuraisOldValue] =
    useState(null);

  const nivelEscolaridadeValue = EducationStore(
    (state) => state.nivelEscolaridadeValue
  );

  const matriculaEscolaValue = EducationStore(
    (state) => state.matriculaEscolaValue
  );

  const qualidadeEscolasRuraisValue = EducationStore(
    (state) => state.qualidadeEscolasRuraisValue
  );

  const setNivelEscolaridadeValue = EducationStore(
    (state) => state.setNivelEscolaridadeValue
  );

  const setMatriculaEscolaValue = EducationStore(
    (state) => state.setMatriculaEscolaValue
  );

  const setQualidadeEscolasRuraisValue = EducationStore(
    (state) => state.setQualidadeEscolasRuraisValue
  );

  const setNivelEscolaridadeImage = EducationStore(
    (state) => state.setNivelEscolaridadeImage
  );

  const setMatriculaEscolaImage = EducationStore(
    (state) => state.setMatriculaEscolaImage
  );

  const setQualidadeEscolasRuraisImage = EducationStore(
    (state) => state.setQualidadeEscolasRuraisImage
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [nivelEscolaridade, matriculaEscola, qualidadeEscolasRurais] =
          await Promise.all([
            Api.getNivelEscolaridade(distrito, null, matriculaEscolaValue, qualidadeEscolasRuraisValue),
            Api.getMatriculaEscola(distrito, nivelEscolaridadeValue, null, qualidadeEscolasRuraisValue),
            Api.getQualidadeEscolasRurais(distrito, nivelEscolaridadeValue, matriculaEscolaValue, null),
          ]);
        setNivelEscolaridade(Functions.buildPieGraphParams2(nivelEscolaridade));
        setMatriculaEscola(Functions.buildPieGraphParams2(matriculaEscola));
        setQualidadeEscolasRurais(
          Functions.buildPieGraphParams2(qualidadeEscolasRurais)
        );
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    };
    fetchData();
  }, [distrito, nivelEscolaridadeValue, matriculaEscolaValue, qualidadeEscolasRuraisValue]);

  const onNivelEscolaridadeClick = (value) => {
    setNivelEscolaridadeValue(value);
  };

  const onMatriculaEscolaClick = (value) => {
    setMatriculaEscolaValue(value);
  };

  const onQualidadeEscolasRuraisClick = (value) => {
    setQualidadeEscolasRuraisValue(value);
  };

  return (
    <div className={styles.educationL1}>
      <div className={styles.smallPiegraph}>
        {nivelEscolaridade && (
          <PieGraph
            data={nivelEscolaridade}
            text="NÍVEL ESCOLARIDADE"
            onLegendClick={onNivelEscolaridadeClick}
            currentValue={nivelEscolaridadeValue}
            oldValue={nivelEscolaridadeOldValue}
            onOldValue={setNivelEscolaridadeOldValue}
            onImageReady={setNivelEscolaridadeImage}
          />
        )}
      </div>
      <div className={styles.smallPiegraph}>
        {matriculaEscola && (
          <PieGraph
            data={matriculaEscola}
            text="MATRICULADO ESCOLA"
            onLegendClick={onMatriculaEscolaClick}
            currentValue={matriculaEscolaValue}
            oldValue={matriculaEscolaOldValue}
            onOldValue={setMatriculaEscolaOldValue}
            onImageReady={setMatriculaEscolaImage}
          />
        )}
      </div>
      <div className={styles.smallPiegraph}>
        {qualidadeEscolasRurais && (
          <PieGraph
            data={qualidadeEscolasRurais}
            text="QUALIDADE DAS ESCOLAS RURAIS"
            onLegendClick={onQualidadeEscolasRuraisClick}
            currentValue={qualidadeEscolasRuraisValue}
            oldValue={qualidadeEscolasRuraisOldValue}
            onOldValue={setQualidadeEscolasRuraisOldValue}
            onImageReady={setQualidadeEscolasRuraisImage}
          />
        )}
      </div>
    </div>
  );
}

export default EducationL1;
